export default "__VITE_ASSET__Bzch12iV__"